import { RootState } from 'types/redux';

export const selectAccessToken = (state: RootState) => state.auth.accessToken;
